import styled, { css } from "styled-components";
import color from "../../../helpers/color";
import animation from "../../../helpers/animation";
import transition from "../../../helpers/transition";
const Icon = /*#__PURE__*/styled.svg.attrs(({
  size,
  width,
  height,
  viewBox,
  ...props
}) => ({
  width: width || size || 22,
  height: height || size || 22,
  ...props
})).withConfig({
  displayName: "Icon",
  componentId: "sc-436uyx-0"
})(["", ";", " color:", ";", ""], animation, transition(["transform"], 0.3), color, ({
  onClick
}) => onClick && css(["cursor:pointer;"]));
Icon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  viewBox: "0 0 22 22"
};
Icon.displayName = "Icon";
export default Icon;
//# sourceMappingURL=Icon.js.map